//const CATALOGO_GENERICO =2
const state = {
    msgErrorLiquidacion: null,
    msgErrorOrdenPago: null,
    formModel: null, //siempre tiene que estar en null inicialmente, es la forma en la que la que la tabla de liquidacion sabe si esta en modo usuario o modo publico
    formsModels:[], // siempre tiene que estar iniciado en 0
    treeGrant: null,
    tipoCatalogo: null,
    parcialidades: null,
    totalLiquidacion: null,
    resumenLiquidacion : null,
    isCalculando: false, //No pueden ser null por que se evaluan una vez mostrado el liqform
    isGenerando: false, //No pueden ser null por que se evaluan una vez mostrado el opcionesTableLiq
    isCobrando: false,
    datosPago: null,
    subsidiosAplicados: [],
    catalogCobro: null,
    isShowModalCobro: false,
    isLiqFormCollapse: false,
    isShowSideCobro:false,
    pdfsGenerated:[],
    permisoExentar:false, //por default es false ya que tambien se usa en portal contribuyete
    timeOutMonitor : 90000,
    archivoB64 : {contenido:'', nombre:'', tipo:''}
}

// mutations
const mutations = {

  updateArchivoB64(state, newA){
    state.archivoB64 = newA;
  },
  updateTimeOutMonitor(state, newIs){
    state.timeOutMonitor = newIs;
  },

  updateIsShowSideCobro(state, newIs){
    state.isShowSideCobro = newIs;
  },
  updatePdfsGenerated(state, newPdfsGenerated){
    state.pdfsGenerated = newPdfsGenerated;
  },
  updateIsShowModalCobro(state, newIsShowModalCobro){
    state.isShowModalCobro = newIsShowModalCobro;
  },
  updateIsLiqFormCollapse(state, newIs){
    state.isLiqFormCollapse = newIs;
  },
  updateCatalogCobro(state, newCatalogCobro){
    state.catalogCobro = newCatalogCobro;
    state.permisoExentar = newCatalogCobro.permisoExentar;
  },
  updateIsGenerando (state, newIsGenerando) {
    state.isGenerando = newIsGenerando;
  },
  updateIsCobrando (state, newIsCobrando) {
    state.isCobrando = newIsCobrando;
  },
  updateTipoCatalogo(state, newTipo) {
    state.tipoCatalogo = newTipo;
  },
  updateItemSelected (state, newItemSelected) {
    state.formModel.itemSelected = newItemSelected;
  },
  updateMsgErrorOrdenPago (state, newMsgErrorOrdenPago) {
    state.msgErrorOrdenPago = newMsgErrorOrdenPago;
  },
  updateMsgErrorLiquidacion (state, newMsgErrorLiquidacion) {
    state.msgErrorLiquidacion = newMsgErrorLiquidacion;
  },
  updateTitleInNum1 (state, newTitle){
    state.formModel.inNum1.title=newTitle;
  },
  updateFormModel (state, newFormModel){
    state.formModel = newFormModel;
  },
  cleanFormsModels(state){
    state.formsModels =[];
  },
  addToFormsModels(state, newForm){
    state.formsModels.push(newForm);
  },
  updateNombreModel (state, newNombreModel){
    state.nombreModel = newNombreModel;
  },
  updateObsModel (state, newObsModel){
    state.obsModel = newObsModel;
  },
  updateTreeGrant (state, newTreeGrant){
    state.treeGrant = newTreeGrant;
  },
  updateParcialidades (state, newParcialidades){
    state.parcialidades = newParcialidades;
  },
  updateTotalLiquidacion (state, newTotal){
    state.totalLiquidacion = newTotal;
  },
  updateResumenLiquidacion (state, newResumen){
    state.resumenLiquidacion = newResumen;
  },
  updateIsCalculando (state, newIsCalculando){
    state.isCalculando = newIsCalculando;
  },
  updateDatosPago (state, newDatosPago){
    state.datosPago = newDatosPago;
  },
  updateSubsidiosAplicados(state, newSubs){
    state.subsidiosAplicados = newSubs;
  },
  updateidxUltParcialidad (state, newIdx){
    state.formModel.idxUltParcialidad = newIdx;
  },
  clearResultsCobro(){
    state.msgErrorLiquidacion= null,
    state.msgErrorOrdenPago= null,
    state.parcialidades= null,
    state.totalLiquidacion= null,
    state.datosPago= null
  },
  configLiqFormModelFor(state, itemSelected){
    var fechaActual = new Date();
    var model= {
        itemSelected: itemSelected,
        idxUltParcialidad: 999, 
        quitarRedondeo:false,
        isLineaCaptura: "false",
        isConFacturaGral:"true",
        formaPagoDesc:"Efectivo",
        inTxtNombre: {title: "Nombre del Contribuyente", model: (state.formModel==null?'':state.formModel.inTxtNombre.model)},
        inTxtObs: {model:""},
        inTxt1: {title:"", model:"", numDato:0},
        inTxt2: {title:"", model:"", numDato:0},
        inTxt3: {title:"", model:"", numDato:0},
        inTxt4: {title:"", model:"", numDato:0},
        inTxt5: {title:"", model:"", numDato:0},
        inTxt6: {title:"", model:"", numDato:0},
        inTxt7: {title:"", model:"", numDato:0},
        inTxt8: {title:"", model:"", numDato:0},
        inTxt9: {title:"", model:"", numDato:0},
        selectA: {title:"", options: [],model: '', numDato:0},
        select1: {title:"", options: [],model: '', numDato:0},
        select2: {title:"", options: [],model: '', numDato:0},
        select3: {title:"", options: [],model: '', numDato:0},
        inNum1: {title:"", model:"", numDato:0},
        inNum2: {title:"", model:"", numDato:0},
        inNum3: {title:"", model:"", numDato:0},
        inNum4: {title:"", model:"", numDato:0},
        inNum5: {title:"", model:"", numDato:0},
        inNum6: {title:"", model:"", numDato:0},
        inNum7: {title:"", model:"", numDato:0},
        inNum8: {title:"", model:"", numDato:0},
        inNum9: {title:"", model:"", numDato:0},
        inNum10: {title:"", model:"0", numDato:0},
        inNum11: {title:"", model:"", numDato:0},
        inDate1: {title:"", model:(fechaActual.toISOString()).substring(0,10), numDato:0},
        inDate2: {title:"", model:(fechaActual.toISOString()).substring(0,10), numDato:0},
        chkBox1: {title:"", model:"false", numDato:0},
        fechaVencimiento : {title:"", model:null, numDato:0},
        isIngresoGenerico : false,
    }
    switch(itemSelected) {
        case "Orden de Pago":
            model.inTxtNombre.title="";
            model.inTxt4.title="Orden de Pago";
            break;

        case "Subsidios":
          model.inTxtNombre.title="";
          break;    

        case "Integración IUSA":
          model.inTxtNombre.title="";
          break; 

        case "Transacciones TPV":
        case 'Registro Pagos Externos':
          model.inTxtNombre.title="";
          break;

        case "Parquímetro Validación":
          model.inTxtNombre.title="";
          break;

        case "Liquidar Predial":
            model.inTxtNombre.title="";
            model.inTxt1.title="Clave Catastral";
            configSelect1TipoLiq(model);
            break;

        case "Convenio Predial":
            model.inTxtNombre.title="";
            model.inTxt1.title="Clave Catastral";
            configLiqFormModelForManual(model, fechaActual);
            break;

        case "Registro SIIGEM":
            model.inTxtNombre.title="";
            break;
        
        case "Liquidar Traslado":
            model.inTxtNombre.title="Nombre Nuevo Propietario";
            model.inTxt1.title="Clave Catastral";
            model.inNum1.title="$ Valor de operación";
            model.inNum2.title="% Cobrable";
            model.inNum2.model="100";
            model.inDate1.title="Fecha de operación";
            break;

        case "Convenio Traslado":
            model.inTxtNombre.title="";
            model.inTxt1.title="Clave Catastral";
            configLiqFormModelForManual(model, fechaActual);
            break;

        case "Liquidar Conjunto":
            configSelectA(model, "Concepto", state.catalogCobro.conjuntos);
            model.inDate1.title="Fecha de publicación";
            break;

        case "Liquidar Agua Potable":
            model.inTxtNombre.title="";
            model.inTxt3.title="Número de Cuenta";
            configSelect1TipoLiq(model);
            break;

        case "Convenio Agua Potable":
            model.inTxtNombre.title="";
            model.inTxt3.title="Número de Cuenta";
            configLiqFormModelForManual(model, fechaActual);
            configSelectA(model, "Concepto", ["SUMINISTRO DE AGUA POTABLE", "SERVICIO DE DRENAJE", "TRATAMIENTO DE AGUAS RESIDUALES", "OPERACIÓN Y MANTENIMIENTO DE LA RED"])
            break;


        case "Otros Servicios Agua Potable":
        case "Reconexión a la red":
        case "Aparato medidor de agua":
        case "Conexión Servicio Convenio":
          model.inTxtNombre.title="";
          model.inTxt3.title="Número de Cuenta";
          configLiqFormModelForManual(model, fechaActual);
          configLiqFormModelForManual(model, fechaActual);
          break;

        case "Suministro Agua en Bloque":
          model.select1.title="Año";
          model.select1.options= state.catalogCobro.añosCodigo;
          model.select1.model= fechaActual.getFullYear();
          model.select2.title="Mes Inicial";
          model.select2.options=["1","2","3","4","5","6","7","8","9","10","11","12"];
          model.select2.model= fechaActual.getMonth()+1;
          model.select3.title="Mes Final";
          model.select3.options=["1","2","3","4","5","6","7","8","9","10","11","12"];
          model.select3.model= fechaActual.getMonth()+1;
          model.inNum1.title="Consumo (m3)";
          model.inNum1.model="0.00";
          break;

        case "Instalación Medidor Agua":
        case "Instalación Medidor Drenaje":
        case "Derivación Toma de Agua":
        case "Conexión Servicio de Agua":
        case "Certificación No Adeudo Agua":
        case "Servicio de desazolve":
        case "Reparación de descarga de aguas":
        case "Aperturas":
        case "Cambio de propietario":
          model.inTxtNombre.title="";
          model.inTxt3.title="Número de Cuenta";
          break;

        case "Conexión Servicio Drenaje":
          model.inTxtNombre.title="";
          model.inTxt3.title="Número de Cuenta";
          model.inNum1.title="Diámetro (mm)";
          model.inNum1.model="0.00";
          break;

        case "Revisiones e Inspecciones":
          model.inTxtNombre.title="";
          model.inTxt3.title="Número de Cuenta";
          configSelectA(model, "Tipo de inspección", state.catalogCobro.aguaInspecciones);
          break;
        
        case "Certificaciones al padrón":
          model.inTxtNombre.title="";
          model.inTxt3.title="Número de Cuenta";
          configSelectA(model, "Tipo de documento", state.catalogCobro.aguaOtrosDocs);
          break;

        case "Servicio de pipa por m3":
          configSelectA(model, "Tipo de uso", state.catalogCobro.aguaTiposUso);
          model.inNum1.title="Cantidad (m3)";
          model.inNum1.model="0.00";
          break;

        case "Certificaciones fuera del padrón":
          configSelectA(model, "Tipo de documento", state.catalogCobro.aguaDocsNoPadron);
          break;

        case "Dictamen Factibilidad":
        case "Certificación No Registro Agua":
          break;

        case "Control Conexión Agua":
        case "Control Conexión Drenaje":
          configSelectA(model, "Tipo de condominio", state.catalogCobro.aguaConjuntos);
          model.inNum1.title="Dimensión (m2)";
          model.inNum1.model="0.00";
          break;

        case "Conexión Agua en Bloque":
          configSelectA(model, "Tipo de condominio", state.catalogCobro.aguaConjuntos);
          model.inNum1.title="Consumo (m3)";
          model.inNum1.model="0.00";
          break;

        case "Permiso Suministro en Pipa":
          model.inNum1.title="No. pipas/camiones";
          model.inNum1.model="0.00";
          break;

        case "Servicios relacionados al suministro":
          model.inTxtNombre.title="";
          model.inTxt3.title="Número de Cuenta";
          model.inNum1.title="Cantidad";
          model.inNum1.model="0.00";
          configSelectA(model, "Concepto", state.catalogCobro.aguaOtrosAgua);
          if(state.catalogCobro.subconceptosrelagua!=null && state.catalogCobro.subconceptosrelagua.length){
            configSelect2(model, "Subconcepto", state.catalogCobro.subconceptosrelagua);
          }
          
          break;

        case "Liquidar Anuncio Fijo":
            configTxtNombreClaveForContrib(model);
            configSelect1TipoLiq(model);
            break;

        case "Convenio Anuncio Fijo":
            configTxtNombreClaveForContrib(model);
            configLiqFormModelForManual(model, fechaActual);
            break;

        case "Liquidar Anuncio Eventual":
            configSelectA(model, "Tipo de Anuncio", state.catalogCobro.anuncios);
            model.inDate1.title="Inicio de Operación";
            model.inDate2.title="Fin de Operación";
            model.chkBox1.title="Notificado";
            model.inNum10.title="No. actos";
            break;

        case "Liquidar Comercio Fijo":
            configTxtNombreClaveForContrib(model);
            configSelect1TipoLiq(model);
            break;

        case "Convenio Comercio Fijo":
            configTxtNombreClaveForContrib(model);
            configLiqFormModelForManual(model, fechaActual);
            break;

        case "Liquidar Comercio Eventual":
            configSelectA(model, "Concepto", state.catalogCobro.juegoseventual);
            model.inNum1.title="Base Gravable";
            model.inDate1.title="Fecha de operación";
            break;
        
        case "Liquidar Registro Civil":
            configSelectA(model, "Concepto", state.catalogCobro.registro);
            break;

        case "Licencia Construccion":
            configSelectA(model, "Concepto", state.catalogCobro.desurbanolic);
            model.inDate1.title="Inicio de Obra";
            break;
        
        case "Licencia de construcción validada":
          configSelectA(model, "Concepto", state.catalogCobro.desurbanolic);
          model.inDate1.title="Inicio de Obra";
          configSelect2(model, "Tipología", state.catalogCobro.desurbanolictipologias);
          model.inNum2.title = "No. Niveles";
          model.inTxt1.title="Clave Catastral";
          break;

        case "Liquidar Otros Servicios":
            configSelectA(model, "Concepto", state.catalogCobro.desurbano);
            break;

        case "Liquidar":
            configSelectA(model, "Concepto", state.catalogCobro.administrativas);
            break;

        case "Sacrificio de animales":
            configSelectA(model, "Concepto", state.catalogCobro.rastro);
            break;

        case "Parquímetro":
          model.inTxtNombre.title="Placa";
          configSelectA(model, "Concepto", state.catalogCobro.parquimetro);
          break;

        case "Saldo parquímetro":
          model.inTxtNombre.title="Placa";
          model.inNum1.title="Monto $";
          model.inNum1.model="0.00";
          break;

        case "Corral e Identificacion":
            configSelectA(model, "Concepto", state.catalogCobro.corral);
            break;

        case "Liquidar Puesto Fijo":
            configTxtNombreClaveForContrib(model);
            configSelect1TipoLiq(model);
            break;

        case "Convenio Puesto Fijo":
            configTxtNombreClaveForContrib(model);
            configLiqFormModelForManual(model, fechaActual);
            break;

        case "Liquidar Refrendo":
            configTxtNombreClaveForContrib(model);
            configSelect1TipoLiq(model);
            break;

        case "Convenio Refrendo":
            configTxtNombreClaveForContrib(model);
            configLiqFormModelForManual(model, fechaActual);
            break;

        case "Servicios de Panteon":
            configSelectA(model, "Concepto", state.catalogCobro.panteonserv);
            break;

        case "Otros Servicios por M2":
            configSelectA(model, "Concepto", state.catalogCobro.panteonm2);
            model.inNum1.title="Dimensión (m2)";
            break;

        case "Servicio Consesionado":
            break;

        case "Otros Servicios de Panteon":
            configLiqFormModelForManual(model, fechaActual);
            break;

        case "Liquidar Estacionamiento":
            configTxtNombreClaveForContrib(model);
            configSelect1TipoLiq(model);
            break;

        case "Convenio Estacionamiento":
            configTxtNombreClaveForContrib(model);
            configLiqFormModelForManual(model, fechaActual);
            break;

        case "Liquidar Expedición Licencia Comercio Fijo":
            configTxtNombreClaveForContrib(model);
            model.inDate1.title="Fecha de Expedición";
            break;

        case "Liquidar Expedición Licencia Comercio Eventual":
            configSelectA(model, "Concepto", state.catalogCobro.alcohol);
            model.inDate1.title="Fecha de Expedición";
            break;

        case "Liquidar Refrendo Comercio Fijo":
            configTxtNombreClaveForContrib(model);
            break;

        case "Convenio Refrendo Comercio Fijo":
            configTxtNombreClaveForContrib(model);
            configLiqFormModelForManual(model, fechaActual);
            break;

        case "Liquidar Servicio":
            configSelectA(model, "Concepto", state.catalogCobro.seguridad);
            model.inDate1.title="Inicio del Servicio";
            model.inDate2.title="Fin del Servicio";
            break;

        case "Liquidar Servicio Limpieza":
            configSelectA(model, "Concepto", state.catalogCobro.limpieza);
            break;

        case "Liquidar Servicio Catastro":
            configSelectA(model, "Concepto", state.catalogCobro.catastro);
            break;

        case "Liquidar Cuenta Contable":
            configSelectA(model, "Cuenta Contable", state.catalogCobro.cuentas);
            //model.inDate1.title="Fecha del Ingreso"; ya no dejamos que el usuario ingrese la fecha
            configLiqFormModelForManual(model, fechaActual);
            break;

        case "Sanción Administrativa y/o Emisión de actas":
        case "Otros Permisos o Inspecciones":
        case "Impresos y papel epecial":
        case "Liquidar Puesto Eventual":
        case "Liquidar Otro Servicio":
        case "Contribuciones de Mejoras":
        case "Contribuciones servicios ambientales":
        case "Venta de otros bienes y servicios":
        case "Liquidar Otros Servicios Catastro":
        case "Mantenimiento de drenaje":
        case "Servicio de pipa carga":
        case "Desarrollo urbano y obras públicas":
        case "Otros Servicios administrativos":
        case "Otros derechos":
        case "Otros productos":
        case "Ingresos de organismos del deporte":
        case "Otros aprovechamientos":
        case "Uso de vía como estacionamiento":
        case "Certificaciones de pago":
        case "Anuncios publicitarios en general":
        case "Servicios de registro civil en general":
            configLiqFormModelForManual(model, fechaActual);
            break;
        
        default:
          model.isIngresoGenerico = true;

         // if(state.tipoCatalogo==CATALOGO_GENERICO){//2: is catalogo generico
            for(var subCat of state.catalogCobro.subcategorias){
              if(itemSelected == subCat.descripcion){
                configSelectA(model, 'Concepto', subCat.conceptos);                
              }
            }
         // }          
      }
      state.formModel = model;
      configFormFromSelectA();
  },
}




function configSelect1TipoLiq(model){
  model.select1.title="Tipo Liquidacion";
  model.select1.options=state.catalogCobro.tipoliq;
  model.select1.model=state.catalogCobro.tipoliq[0].toString();
}

function configFormFromSelectA(){
  //if(state.tipoCatalogo==CATALOGO_GENERICO){
  if(state.formModel.isIngresoGenerico){
    configClearForCatGenerico();
    configFormFor();
  }else{
    configInNum1TitleFor()
  }
}


function configClearForCatGenerico(){
    var fechaActual = new Date();

    state.formModel.inTxt1= {title:"", model:"", numDato:0};
    state.formModel.inTxt2= {title:"", model:"", numDato:0};
    state.formModel.inTxt3= {title:"", model:"", numDato:0};
    //state.formModel.inTxt4= {title:"", model:"", numDato:0};
    state.formModel.inTxt5= {title:"", model:"", numDato:0};
    state.formModel.inTxt6= {title:"", model:"", numDato:0};
    state.formModel.inTxt7= {title:"", model:"", numDato:0};
    state.formModel.inTxt8= {title:"", model:"", numDato:0};
    state.formModel.inTxt9= {title:"", model:"", numDato:0};
    //selectA: {title:"", options: [],model: '', numDato:0}, este no se mueve por que es el que dio origen a este movimiento
    state.formModel.select1= {title:"", options: [],model: '', numDato:0};
    state.formModel.select2= {title:"", options: [],model: '', numDato:0};
    state.formModel.select3= {title:"", options: [],model: '', numDato:0};
    state.formModel.inNum1= {title:"", model:"", numDato:0};
    state.formModel.inNum2= {title:"", model:"", numDato:0};
    state.formModel.inNum3= {title:"", model:"", numDato:0};
    state.formModel.inNum4= {title:"", model:"", numDato:0};
    state.formModel.inNum5= {title:"", model:"", numDato:0};
    state.formModel.inNum6= {title:"", model:"", numDato:0};
    state.formModel.inNum7= {title:"", model:"", numDato:0};
    state.formModel.inNum8= {title:"", model:"", numDato:0};
    state.formModel.inNum9= {title:"", model:"", numDato:0};
    state.formModel.inNum10= {title:"", model:"0", numDato:0};
    state.formModel.inNum11= {title:"", model:"", numDato:0};
    state.formModel.inDate1= {title:"", model:(fechaActual.toISOString()).substring(0,10), numDato:0};
    state.formModel.inDate2= {title:"", model:(fechaActual.toISOString()).substring(0,10), numDato:0};
    state.formModel.chkBox1= {title:"", model:"false", numDato:0};

    state.formModel.isIngresoGenerico = true;

}


function configFormFor(){
  var concepto = state.formModel.selectA.model;


  for(var ingreso of state.catalogCobro.datosIngresos){
      if(ingreso.concepto == concepto){

        //Padron
        if(ingreso.tipoPadron >0 && ingreso.clave != 102010 && ingreso.clave != 102020){
          state.formModel.inTxtNombre.title="";
        }else{
          if(ingreso.clave == 102010 || ingreso.clave == 102020){
            state.formModel.inTxtNombre.title ="Nombre Nuevo Propietario";
          }else{
            state.formModel.inTxtNombre.title="Nombre del Contribuyente";
          }          
        }

        //Selects
        var sInicial = 1;
        for(var idx in ingreso.datos){
          var dato = ingreso.datos[idx]
          if(dato.tipo == 'select'){
            var select = 'select'+sInicial
            state.formModel[select].title = dato.nombre
            state.formModel[select].options = dato.options
            state.formModel[select].numDato = dato.numero
            sInicial++;
          }
        }

        //Clave 
        for(var idxV in ingreso.datos){
          var datoV = ingreso.datos[idxV]
          if(datoV.tipo == 'clave'){
            if(ingreso.tipoPadron ==1){
              state.formModel.inTxt1.title=datoV.nombre
              state.formModel.inTxt1.numDato = datoV.numero
            }else if(ingreso.tipoPadron ==3){
              state.formModel.inTxt3.title=datoV.nombre
              state.formModel.inTxt3.numDato = datoV.numero
            }else{
              state.formModel.inTxt2.title=datoV.nombre
              state.formModel.inTxt2.numDato = datoV.numero
            }
          }
        }

        //Fechas
        var dInicial = 1;
        for(var idxF in ingreso.datos){
          var datoF = ingreso.datos[idxF]
          if(datoF.tipo == 'date'){
            var date = 'inDate'+dInicial
            state.formModel[date].title = datoF.nombre
            state.formModel[date].numDato = datoF.numero
            dInicial++
          }
        }
        //Numeros
        var nInicial = 1;
        for(var idxN in ingreso.datos){
          var datoN = ingreso.datos[idxN]
          if(datoN.tipo == 'number'){
            var num = 'inNum'+nInicial
            state.formModel[num].title = datoN.nombre
            state.formModel[num].numDato = datoN.numero
            nInicial++
          }
        }

        //Texto
        var tInicial = 5; //del 1 al 4 estan personalizados
        for(var idxT in ingreso.datos){
          var datoT = ingreso.datos[idxT]
          if(datoT.tipo == 'text'){
            var txt = 'inTxt'+tInicial
            state.formModel[txt].title = datoT.nombre
            state.formModel[txt].numDato = datoT.numero
            tInicial++
          }
        }

        //Convenio
        for(var idxC in ingreso.datos){
          var datoC = ingreso.datos[idxC]
          if(datoC.tipo == 'liquidacion'){
            configLiqFormModelForManual(state.formModel, new Date())
          }
        }
      }
  }
}

function configInNum1TitleFor(){
  var concepto = state.formModel.selectA.model;
  var idx;
  for(idx in state.catalogCobro.mapBases){
      var elemento = state.catalogCobro.mapBases[idx];
      if(elemento[0] == concepto){
        state.formModel.inNum1.title = elemento[1];
        //store.commit("updateTitleInNum1", elemento[1]);
      }
  }
}

function configLiqFormModelForManual(model, fechaActual){
  model.select1.title="Año";
  model.select1.options= state.catalogCobro.añosCodigo;
  model.select1.model= fechaActual.getFullYear();
  model.select2.title="Mes Inicial";
  model.select2.options=["1","2","3","4","5","6","7","8","9","10","11","12"];
  model.select2.model= fechaActual.getMonth()+1;
  model.select3.title="Mes Final";
  model.select3.options=["1","2","3","4","5","6","7","8","9","10","11","12"];
  model.select3.model= fechaActual.getMonth()+1;
  model.inNum1.title="Importe";
  model.inNum1.model="0.00";
  model.inNum2.title="Actualización";
  model.inNum2.model="0.00";
  model.inNum3.title="Recargo";
  model.inNum3.model="0.00";
  model.inNum4.title="Multa";
  model.inNum4.model="0.00";
  model.inNum5.title="PAE";
  model.inNum5.model="0.00";
  model.inNum6.title="Subsidio Importe";
  model.inNum6.model="0.00";
  model.inNum7.title="Subsidio Recargo";
  model.inNum7.model="0.00";
  model.inNum8.title="Subsidio Multa";
  model.inNum8.model="0.00";
  model.inNum9.title="Subsidio PAE";
  model.inNum9.model="0.00";
  model.inNum11.title="I.V.A.";
  model.inNum11.model="0.00";
}

function configSelectA(model, title, options){
  model.selectA.title=title;
  model.selectA.options=options;
  model.selectA.model=options[0].toString();
}

function configSelect2(model, title, options){
  model.select2.title=title;
  model.select2.options=options;
  model.select2.model=options[0].toString();
}

function configTxtNombreClaveForContrib(model){
  model.inTxtNombre.title="";
  model.inTxt2.title="Clave de Contribuyente";
}

export default {
  state,
  mutations
}
export {configFormFromSelectA}